/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Location } from '@angular/common';
import { TranslocoService } from '@ngneat/transloco';
import { catchError, switchMap } from 'rxjs/operators';
import { environment } from '../../../../../../environments/environment';
import { LinkableCardSummary } from '../../../../../shared/models';
import { Page } from '../../../../../shared/models/page';
import { RestClientService } from '../../../../../shared/services/rest-client.service';
import { ObservableResult } from '../../../../../shared/store';
import { PlaylistResourceCardsDataService } from './data.service';

export class ApiCardsDataService implements PlaylistResourceCardsDataService {
  constructor(
    private client: RestClientService,
    private translocoService: TranslocoService,
  ) {}

  searchLinkableCards(page: number, size: number, headlineFragment: string, type?: string): ObservableResult<Page<LinkableCardSummary>> {
    const params: Record<string, string> = {
      page: page.toString(),
      size: size.toString(),
      term: headlineFragment,
    };

    if (type) {
      params.type = type;
    }

    return this.client.get<Page<LinkableCardSummary>>(Location.joinWithSlash(environment.apiRootUrl || '', 'cards/linkable'), params).pipe(
      switchMap(({ body }) => ObservableResult.ofSuccess(body)),
      catchError(() => ObservableResult.ofError(this.translocoService.translate('translations.errors.errorGetResource'))),
    );
  }
}
